import React, { FC } from 'react'
import { EnvironmentType } from 'utils'
import { Link } from '../../link/Link'
import { PartnershipAdminLogo } from '../../logo/PartnershipAdminLogo'
import { Menu } from './Menu'
import { LeftContent, RightContent, StyledCol, StyledNav } from '../Navigation'
import { FullPageGrid } from '@epidemicsound/design-system'

interface InternalNavigationProps {
    environment: EnvironmentType
    isAuthenticated: boolean
}

export const InternalNavigation: FC<InternalNavigationProps> = ({
    isAuthenticated,
}) => {
    return (
        <StyledNav>
            <FullPageGrid>
                <StyledCol size={12}>
                    <LeftContent>
                        {isAuthenticated && (
                            <Link to={{ url: '/partners' }}>
                                <PartnershipAdminLogo />
                            </Link>
                        )}
                    </LeftContent>
                    <RightContent>{isAuthenticated && <Menu />}</RightContent>
                </StyledCol>
            </FullPageGrid>
        </StyledNav>
    )
}
